import React from "react";

import { Card, Col } from "reactstrap";
import CardBody from "reactstrap/lib/CardBody";
import { StandardList } from "./StandardList";

export const SysUsers = ({ users }) => {
  let cols = [
    { id: "last_name", title: "Apellido", type: "STRING" },
    { id: "name", title: "Nombre", type: "STRING" },
    { id: "login_id", title: "Usuario", type: "STRING" },
    { id: "image", title: "imagen", type: "IMG", size: "50" },
  ];

  return (
    <>
      <Col>
        <Card>
          <CardBody>
            <StandardList
              title="Listado de personal"
              rows={users}
              cols={cols}
              actions={[]}
            />
          </CardBody>
        </Card>
      </Col>
    </>
  );
};
